import React from 'react';
import { createRoot } from 'react-dom/client';

import '../../index.css';
import '../../momentConfig.ts';
import '../../sentry.ts';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(<App />);
